import { render } from "./UeTripsForeignEditView.vue?vue&type=template&id=2b1e8f6c&scoped=true"
import script from "./UeTripsForeignEditView.vue?vue&type=script&lang=js"
export * from "./UeTripsForeignEditView.vue?vue&type=script&lang=js"

import "./UeTripsForeignEditView.vue?vue&type=style&index=0&id=2b1e8f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1e8f6c"]])

export default __exports__